import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

export const GetandCreateUnit =async(method,data)=>{
    return axios({
        method:method,                                          // This is used to get and create Unit data from API
        url:`${BASE_URL}/LADProducts/add-unit/`,
        data:data
    })

}

export const UpdateAndDeleteUnit = async (method,id, data) => {
    return axios({
        method: method,                                           // This is used to put and delete Unit data from API
        url: `${BASE_URL}LADProducts/add-unit/${id}/`,
        data: data
    });
};

export const ExportUnit = async (method, data, config = {}) => {
    return axios({
        method: method,                         
        url: `${BASE_URL}LADProducts/link-hsn-units/export/`,      // This is used Export (download) Unit data and Link HSN Unit from API
        data: data,
        responseType: 'blob',
        ...config
    });
};

export const ImportUnit = async (method, data) => {
    return axios({
        method: method,
        url: `${BASE_URL}LADProducts/link-hsn-units/import/`,       // This is used to Import (upload) Unit data  and Link HSN Unit from API
        data: data
    });
};

export const GetandCreateLinkUnit =async(method,data)=>{
    return axios({
        method:method,                                          // This is used to get and create Link HSN Unit data from API
        url:`${BASE_URL}/LADProducts/link-hsn-units/`,
        data:data
    })

}

export const GetSpecifiedLinkUnit =async(method,id,data)=>{
    return axios({
        method:method,                                          // This is used to get and create Link HSN Unit data from API
        url:`${BASE_URL}/LADProducts/link-hsn-units/${id}`,
        data:data
    })

}

export const UpdateandDeleteLinkUnit = async (method,id, data) => {
    return axios({
        method: method,                                           // This is used to put and delete Unit Link HSN Unit from API
        url: `${BASE_URL}LADProducts/link-hsn-units/${id}/`,
        data: data
    });
};
